import { List, useDataGrid } from '@refinedev/mui'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import { Chip, Link } from '@mui/material'
import { useNavigate } from 'react-router-dom'

export const RelationalIntroductionLetterDraftsList = () => {
  const navigate = useNavigate()
  const { dataGridProps } = useDataGrid({
    resource: 'relational-introduction-letter-drafts',
  })

  const columns: GridColDef[] = [
    {
      field: 'org_name',
      headerName: 'Org',
      flex: 1,
      minWidth: 180,
      renderCell: ({ row }) => (
        <Link
          component="button"
          underline="hover"
          onClick={() => navigate(`/relational-introduction-letter-drafts/${row.id}`)}
        >
          {row.org_name}
        </Link>
      ),
    },
    { field: 'funder_name', headerName: 'Funder', flex: 1, minWidth: 160 },
    { field: 'fund_name', headerName: 'Opportunity', flex: 1, minWidth: 180 },
    { field: 'version_count', headerName: 'Versions', width: 110 },
    { field: 'version_number', headerName: 'Latest', width: 90 },
    {
      field: 'source',
      headerName: 'Source',
      width: 120,
      renderCell: ({ value }) => <Chip size="small" label={value} />,
    },
    {
      field: 'is_done',
      headerName: 'Status',
      width: 120,
      renderCell: ({ value }) => (
        <Chip
          size="small"
          color={value ? 'success' : 'default'}
          label={value ? 'Done' : 'Draft'}
        />
      ),
    },
    {
      field: 'created_at',
      headerName: 'Updated',
      minWidth: 180,
      flex: 1,
    },
  ]

  return (
    <List>
      <DataGrid
        {...dataGridProps}
        autoHeight
        columns={columns}
        onRowClick={(params) =>
          navigate(`/relational-introduction-letter-drafts/${params.row.id}`)
        }
      />
    </List>
  )
}
